<template>
  <div class="card shadow p-3">
    <div class="card-header border-0">
      <base-title :title="title" popover="Listado de palabras en uso">
        <template slot="button">
          <b-button
            size="sm"
            variant="outline-primary"
            @click="$refs.create.showModal()"
            >{{ $t("add") }}</b-button
          >
        </template>
      </base-title>
    </div>

    <b-row>
      <b-col sm="3" md="2">
        <b-form-select
          v-model="filter.per_page"
          :options="[5, 10, 20, 100]"
          size="sm"
          class="mt-2"
          @input="debouncedGetAnswer()"
        ></b-form-select>
      </b-col>
      <b-col class="ml-auto col-sm-8 col-md-6 col-lg-6 mb-3">
        <b-form-group>
          <b-form-input
            class="form-control-sm"
            id="filter-input"
            v-model="filter.search"
            type="search"
            :placeholder="$t('search')"
            @input="debouncedGetAnswer()"
          ></b-form-input>
        </b-form-group>
      </b-col>
      <b-col md="12" class="table-responsive">
        <b-table
          class="align-items-center table-flush tablesorter table-text"
          hover
          :items="tableData.data"
          :fields="columns"
          :per-page="filter.per_page"
          :busy="
            !Array.isArray(tableData.data) || tableData.data.length === 0
              ? true
              : false
          "
        >
          <template #table-busy>
            <div class="text-center text-danger my-2">
              <span class="h2 text-danger">{{ $t("fail") }}</span>
            </div>
          </template>
          <template v-slot:cell(count)="data">
            {{ countWord(data.item.name) }}
          </template>
          <template
            v-slot:cell(links-created)="data"
            v-if="statistic.total > 0"
          >
            {{
              statistic.data.links_created
                ? statistic.data.find((item) => item.word == data.item.name)
                    .links_created
                : 0
            }}
          </template>
          <template v-slot:cell(actions)="data">
            <b-button
              variant="info"
              size="sm"
              @click="showConuntCountry(data.item.name)"
              v-b-tooltip.hover
              :title="$t('words-labels')"
              ><i class="ri-map-2-line"></i
            ></b-button>
            <b-button
              variant="warning"
              size="sm"
              @click="$refs.create.showModal(data.item)"
              v-b-tooltip.hover
              :title="$t('edit')"
              ><i class="far fa-edit"></i
            ></b-button>
            <b-button
              v-b-tooltip.hover
              :title="$t('delete')"
              variant="danger"
              size="sm"
              @click="deleteWords(data.item.id)"
              ><i class="far fa-trash-alt"></i
            ></b-button>
          </template>
        </b-table>
        <b-pagination
          class="mt-3"
          v-model="filter.page"
          :total-rows="tableData.total"
          :per-page="tableData.per_page"
          :page-count="tableData.per_page"
          @input="changePage"
          first-number
          pills
          size="sm"
          align="center"
        ></b-pagination>
      </b-col>
    </b-row>
    <modal-create ref="create" />
    <b-modal id="modal-1" hide-footer scrollable>
      <template #modal-header>
        <h4>{{ $t("words-labels") }}</h4>
        <b-button
          size="sm"
          variant="outline-light"
          class="ml-auto"
          @click="$bvModal.hide('modal-1')"
        >
          <i class="fas fa-times"></i>
        </b-button>
      </template>
      <div v-if="dataCountryCount">
        <b-table :fields="fields" striped hover :items="dataCountryCount">
          <template #cell(actions)="row">
            <b-button size="sm" @click="row.toggleDetails">
              <i
                :class="
                  row.detailsShowing
                    ? 'ri-arrow-up-s-line'
                    : 'ri-arrow-down-s-line'
                "
              ></i>
            </b-button>
          </template>
          <template #row-details="row">
            <table class="table table-borderless table-sm shadow">
              <thead>
                <tr>
                  <th class="text-center" scope="col">{{ $t("region") }}</th>
                  <th class="text-center" scope="col">{{ $t("count") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, key) in row.item.regions" :key="key">
                  <td class="text-center">{{ value.name }}</td>
                  <td class="text-center">{{ value.count }}</td>
                </tr>
              </tbody>
            </table>
          </template>
        </b-table>
      </div>
      <h1 v-else class="text-center">{{ $t("fail") }}</h1>
    </b-modal>
  </div>
</template>
<script>
import ModalCreate from "../Words/create.vue";
import { mapActions, mapGetters } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";
// import CountTableWord from "./Fees.vue";
import _ from "lodash";
export default {
  name: "user-table",
  props: {
    type: {
      type: String,
    },
    title: String,
    modal: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    ModalCreate,
    // CountTableWord,
  },
  async created() {
    await this.loadData();
    await this.getWordsCounts();
    this.debouncedGetAnswer = _.debounce(this.loadData, 300);
    console.log(this.tableData);
  },
  data() {
    return {
      dataUser: [],
      userId: null,
      dataCountryCount: "",
      filter: {
        page: 1,
        per_page: 5,
        search: null,
      },
    };
  },
  methods: {
    ...mapActions({
      getWords: "words/get",
      getWordsCounts: "words/getCounts",
      delete: "words/delete",
    }),
    async loadData() {
      await this.getWords(this.filter);
    },
    countWord(word) {
      if (word !== undefined && this.statistic.data) {
        let data = this.statistic.data.find((item) => item.word == word);
        return data ? data.count : 0;
      }
    },
    showConuntCountry(word) {
      if (word !== undefined && this.statistic.data) {
        let data = this.statistic.data.find((item) => item.word == word);
        this.dataCountryCount = data ? data.locations : null;
      }
      this.$bvModal.show("modal-1");
    },
    async changePage(value) {
      (this.filter.page = value), await this.loadData();
    },
    async deleteItem(id) {
      try {
        const res = await this.delete(id);
        this.$toast.success(res.message, {
          position: "top-right",
        });
        this.$bvModal.hide("bv-modal-words");
      } catch (error) {
        console.log(error);
      }
    },
    async deleteWords(id) {
      await Swal.fire({
        title: this.$t("are_you_sure?"),
        text: this.$t("question_delete_words"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#172b4d",
        cancelButtonColor: "#d33",
        confirmButtonText: this.$t("yes"),
        cancelButtonText: this.$t("not"),
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            this.deleteItem(id);
          } catch (error) {
            console.log(error);
          }
        }
      });
    },
  },
  computed: {
    ...mapGetters({
      tableData: "words/words",
      statistic: "words/wordsCounts",
    }),
    columns() {
      return [
        { label: this.$t("words"), key: "name", class: "text-center" },
        // { label: this.$t("at-this-moment"), key: "e", class: "text-center" },
        { label: this.$t("usage-history"), key: "count", class: "text-center" },
        {
          label: this.$t("links-created"),
          key: "links_created",
          class: "text-center",
        },
        { label: this.$t("actions"), key: "actions", class: "text-center" },
      ];
    },
    fields() {
      return [
        {
          key: "country",
          label: this.$t("country"),
          class: "text-center",
        },
        {
          key: "count",
          label: this.$t("count"),
          class: "text-center",
        },
        {
          key: "actions",
          label: "",
          class: "text-center",
        },
      ];
    },
  },
};
</script>